const Shimmer = ({ className = "" }) => (
  <div className={`animate-pulse rounded-xl bg-gray-200 ${className}`} />
);

const ProfileSkeletonMobile = () => (
  <div className="min-h-screen bg-white px-4 pb-12 pt-10">
    {/* Avatar + name */}
    <div className="mx-auto flex max-w-lg flex-col items-center text-center">
      <Shimmer className="mb-4 h-40 w-40 rounded-full" />
      <Shimmer className="h-7 w-40 rounded-lg" />
      <Shimmer className="mt-2 h-5 w-52 rounded-lg" />

      {/* Nav buttons */}
      <div className="mt-8 flex w-full flex-col gap-3">
        {[1, 2, 3, 4, 5].map((i) => (
          <Shimmer key={i} className="h-[58px] w-full rounded-2xl" />
        ))}
      </div>

      {/* Logout */}
      <Shimmer className="mt-20 h-6 w-24 rounded-lg" />
    </div>
  </div>
);

const ProfileSkeletonDesktop = () => (
  <div className="flex min-h-screen bg-white">
    {/* ── Left sidebar ── */}
    <aside className="w-72 shrink-0 border-r border-gray-100 px-6 py-10">
      {/* Avatar */}
      <div className="flex flex-col items-center text-center">
        <Shimmer className="mb-4 h-28 w-28 rounded-full" />
        <Shimmer className="h-6 w-32 rounded-lg" />
        <Shimmer className="mt-2 h-4 w-44 rounded-lg" />
      </div>

      {/* Nav items */}
      <div className="mt-8 flex flex-col gap-2">
        {[1, 2, 3, 4, 5].map((i) => (
          <Shimmer key={i} className="h-12 w-full rounded-2xl" />
        ))}
      </div>

      {/* Logout */}
      <Shimmer className="mt-10 h-5 w-20 rounded-lg" />
    </aside>

    {/* ── Main content ── */}
    <main className="flex-1 px-10 py-10">
      {/* Section heading */}
      <Shimmer className="mb-8 h-8 w-56 rounded-lg" />

      {/* Avatar + name row */}
      <div className="mb-8 flex items-center gap-5">
        <Shimmer className="h-20 w-20 rounded-full" />
        <div className="flex flex-col gap-2">
          <Shimmer className="h-6 w-36 rounded-lg" />
          <Shimmer className="h-4 w-48 rounded-lg" />
        </div>
      </div>

      {/* Form fields */}
      <div className="flex max-w-xl flex-col gap-6">
        {[1, 2, 3].map((i) => (
          <div key={i} className="flex flex-col gap-2">
            <Shimmer className="h-4 w-20 rounded" />
            <Shimmer className="h-14 w-full rounded-2xl" />
          </div>
        ))}
        {/* Save button */}
        <Shimmer className="mt-2 h-14 w-full rounded-2xl" />
      </div>
    </main>
  </div>
);

/**
 * ProfileSkeleton — shown while the profile API fetch is in flight.
 * Renders a layout-accurate shimmer for mobile or desktop based on `isMobile`.
 */
export default function ProfileSkeleton({ isMobile }) {
  return isMobile ? <ProfileSkeletonMobile /> : <ProfileSkeletonDesktop />;
}
